import { useQuery } from '@apollo/client';
import { useState } from 'react';
import { ArrowLeft, ArrowRight, X } from 'react-feather';
import CustomAutoComplete from '@myComponents/CustomAutoComplete';
import { ReactSortable } from 'react-sortablejs';
import { ListGroupItem, Row, Col, Button, Spinner } from 'reactstrap';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useOptions } from '../../../../../hooks/useOptions';
import { useForm } from 'react-hook-form';
import { selectThemeColors } from '@utils';
import SelectAsyncOptions from '@components/input/SelectAsyncOptions';
import FallbackSpinner from '@components/spinner/Fallback-spinner';
import {
  ListEpisodes
} from '../../../../../graphql/Query/roads';

const MySwal = withReactContent(Swal);

const ItemSelectedGroup = ({ episode, onDelete }) => {

  return (
    <ListGroupItem className="handle">
      <div className="d-flex justify-content-between align-items-center">
        <div>
          {!episode.default && (
            <img
              src={episode.cover}
              className="rounded-circle me-2"
              height="50"
              width="50"
              alt={episode.title}
            />
          )}
        </div>
        <div className="mt-0 mb-0 flex-grow-1 ms-2">
          <h5>{episode.title}</h5>
          <div style={{ fontSize: '10px', color: '#6c757d' }}>{Array.isArray(episode.gender) ? episode.gender.join(' ') : (episode.gender ?? '')}</div>
        </div>
        <X
          size={34}
          color="red"
          style={{ cursor: 'pointer' }}
          onClick={() => onDelete(episode._id)}
        />
      </div>
    </ListGroupItem>
  );
};

const ContentCreator = ({ stepper, handleOnSubmit, defaultValues }) => {
  const { loading, options } = useOptions();

  const { setValue, watch } = useForm({
    defaultValues: {
      ...defaultValues,
      tags: loading ? [] : options.tagsOptions
    }
  });

  const [availableEpisodes, setAvailableEpisodes] = useState([]);
  const [selectedEpisodes, setSelectedEpisodes] = useState([]);

  const { loading: _loading } = useQuery(ListEpisodes, {
    variables: {
      search: {
        activity: '',
        status: 'ACTIVE',
        q: '',
        perPage: 2000,
        page: 1
      }
    },

    onCompleted: ({ listEpisodes: data }) => {
      const initialSelected = data.docs.filter(episode =>
        defaultValues.episodes.includes(episode._id)
      );

      const initialAvailable = data.docs.filter(episode =>
        !defaultValues.episodes.includes(episode._id)
      );
      console.log('initialSelected', initialSelected);
      console.log('initialAvailable', initialAvailable);
      setSelectedEpisodes(initialSelected);
      setAvailableEpisodes(initialAvailable);
    }
  });

  const onSubmit = () => {

    if (!selectedEpisodes.length === 0) {
      return MySwal.fire({
        title: 'Error!',
        text: ' Por favor selecciona un episodio!',
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary'
        },
        buttonsStyling: false
      });
    }
    handleOnSubmit({ episodes: selectedEpisodes.map((item) => item._id) }, false);
    stepper.next();
  };


  const handleDelete = (id) => {
    setSelectedEpisodes([...selectedEpisodes.filter((episode) => episode._id !== id)]);
  };

  if (_loading) {
    return <FallbackSpinner />;
  }

  return (
    <>
      <div className="content-header">
        <h5 className="mb-0">Cargar Contenido</h5>
        <small className="text-muted">
          Busca y agrega los episodios y actividades
        </small>
      </div>
      <Row>
        <Col>
          <Row>
            <Col md="4" sm="12">
              <Row>
                <Col md={12}>
                  <h5 className="my-1">Filtrar por Tags</h5>
                  <SelectAsyncOptions
                    theme={selectThemeColors}
                    disabled={loading}
                    options={options.tagsOptions}
                    tagsSelected={watch('tags')}
                    setOptions={(tags) => setValue('tags', tags)}
                  />
                </Col>
                <Col md={12} className="mt-2">
                  <SelectAsyncOptions
                    theme={selectThemeColors}
                    options={!_loading ? availableEpisodes?.map((e) => { return { name: e.title, value: e._id, data: e }; }) : []}
                    tagsSelected={[]}
                    setOptions={(episodes) => {
                      setSelectedEpisodes([...selectedEpisodes, episodes[0].data]);
                    }}
                  />
                </Col>
              </Row>
            </Col>
            <Col md="1" />
            <Col md="7" sm="12">
              <h4 className="my-1">Episodios Seleccionados</h4>
              <ReactSortable
                tag="ul"
                className="list-group sortable"
                group="shared-handle-group"
                handle=".handle"
                list={selectedEpisodes}
                setList={setSelectedEpisodes}
              >
                {selectedEpisodes.map((episode) => {
                  return (
                    <ItemSelectedGroup
                      key={episode._id}
                      episode={episode}
                      onDelete={handleDelete}
                    />
                  );
                })}
              </ReactSortable>
            </Col>
          </Row>
        </Col>
      </Row>

      <div className="d-flex justify-content-between mt-4">
        <div></div>
        <Button
          type="submit"
          color="primary"
          className="btn-next"
          onClick={() => onSubmit()}
        >
          <span className="align-middle d-sm-inline-block d-none">
            Siguiente
          </span>
          <ArrowRight size={14} className="align-middle ms-sm-25 ms-0" />
        </Button>
      </div>
    </>
  );
};

export default ContentCreator;
